import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from 'common/BaseComponent';
import theme from './AttachmentList.scss';

export default class AttachmentList extends BaseComponent {

    previews = () => {
        return this.props.value.map((file, index) => {
            return (
                <li key={index}>
                    <a href="#" onClick={() => this.props.onDownload(index)} role="button" title={file.displayableName}>{file.displayableName}</a>
                </li>
            )
        });
    };

    render() {
        return (
            <div className={theme.blcDocument}>
                <h3>{this.props.header}</h3>
                <div>
                    <ul>
                        {this.previews()}
                    </ul>
                </div>
            </div>
        )
    }
}

AttachmentList.propTypes = {

    /**
     * Java Script object, with attribute id as file id and name as file name
     */
    value: PropTypes.array.isRequired,

    /**
     * Attachment list header
     */
    header: PropTypes.string.isRequired,

    /**
     * CSS class name
     */
    className: PropTypes.string,

    /**
     * Function, called on document download
     */
    onDownload: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/dialogs/VPRekla/EditComplaint/AttachmentList/index.js